import React from 'react';
import { Helmet } from 'react-helmet-async';
import AppointmentForm from '@/components/forms/AppointmentForm';
import { LocalBusinessSchema, BreadcrumbSchema } from '@/components/seo/SchemaMarkup';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Contact Fort Worth Dental | Schedule Appointment | (817) 985-3337</title>
        <meta name="description" content="Contact Fort Worth Dental at 4620 Citylake Blvd W, Fort Worth TX 76132. Schedule your appointment today. Open Mon-Fri. Call (817) 985-3337." />
        <meta name="keywords" content="fort worth dental phone number, dentist near me fort worth, dental appointment fort worth tx, fort worth dental address, schedule dental appointment" />
        <link rel="canonical" href="https://fortworthdental.com/contact-us" />
      </Helmet>
      
      {/* Schema.org Structured Data */}
      <LocalBusinessSchema />
      <BreadcrumbSchema items={[
        { name: "Home", url: "https://fortworthdental.com/" },
        { name: "Contact Us", url: "https://fortworthdental.com/contact-us" }
      ]} />
      
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-800 mb-4">Contact Us</h1>
          <p className="text-xl text-gray-600">We'd love to hear from you!</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div>
            <div className="bg-white p-8 rounded-lg shadow-lg mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Fort Worth Dental</h2>
              <div className="space-y-4 text-gray-700">
                <div>
                  <h3 className="font-bold text-gray-800">Address:</h3>
                  <p>4620 Citylake Blvd W<br/>Fort Worth, TX 76132</p>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">Phone:</h3>
                  <p><a href="tel:8179853337" className="text-teal-600 hover:text-teal-700">(817) 985-3337</a></p>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">Implant Center:</h3>
                  <p><a href="tel:8178544329" className="text-teal-600 hover:text-teal-700">(817) 854-4329</a></p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Office Hours</h3>
              <div className="space-y-2 text-gray-700">
                <div className="flex justify-between">
                  <span className="font-semibold">Monday:</span>
                  <span>9:00am – 5:00pm</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">Tuesday:</span>
                  <span>9:00am – 6:00pm</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">Wednesday:</span>
                  <span>7:00am – 5:00pm</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">Thursday:</span>
                  <span>9:00am – 6:00pm</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">Friday:</span>
                  <span>7:00am – 2:00pm</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <AppointmentForm />
          </div>
        </div>

        {/* Google Map Embed */}
        <div className="max-w-6xl mx-auto mt-12">
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">Find Us</h2>
            <div className="relative w-full" style={{ paddingBottom: '45%' }}>
              <iframe
                title="Fort Worth Dental Location - 4620 Citylake Blvd W, Fort Worth TX"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3357.5!2d-97.4404!3d32.7284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e6e09b6e0d6d7%3A0x7a5c5e6e1e9d6e7a!2s4620%20Citylake%20Blvd%20W%2C%20Fort%20Worth%2C%20TX%2076132!5e0!3m2!1sen!2sus!4v1"
                className="absolute inset-0 w-full h-full rounded-lg"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="google-map-embed"
              />
            </div>
            <p className="text-center text-gray-500 text-sm mt-3">
              4620 Citylake Blvd W, Fort Worth, TX 76132 &mdash;{' '}
              <a 
                href="https://maps.google.com/maps?q=4620+Citylake+Blvd+W,+Fort+Worth,+TX+76132" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-teal-600 hover:underline"
              >
                Get Directions
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
